import React from 'react'
import { ReactComponent } from './rewards.svg'
import { MergeReactElementProps } from '../types'

interface RewardsProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', RewardsProps>

export const Rewards = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = '#9a9a9a' } = props
    return <ReactComponent stroke={color} ref={ref} {...props} />
  }
)
